var $f0c4e76101f61910$exports = {};
$f0c4e76101f61910$exports = {
  "alert": "H\xE4lytys",
  "dismiss": "Hylk\xE4\xE4"
};
export { $f0c4e76101f61910$exports as default };